import { createStandardAction } from 'typesafe-actions'

import { CoverageActionTypes } from '../coverage.types'

export const setIsCoverageStaleAction = createStandardAction(
  CoverageActionTypes.SET_MAY_REQUIRE_COVERAGE_FETCH,
)<boolean>()

export const setIsCoverageStale = (value: boolean) => async dispatch => {
  dispatch(setIsCoverageStaleAction(value))
}
